import type { LatLng } from '@/api/modules/delivery/types'

export interface Basket {
  items: Item[]
  persons: Persons
  additives: AdditiveItem[]
  total_price: number
  total_amount: number
  amount_to_pay: number
  promo_code: Promocode | null
  bonuses: Bonuses | null
  max_number_of_persons: number
  items_count: number
  delivery: Delivery | null
  gifts: Gift[]
  proposition: Proposition
  client_packs: ClientPack[]
  do_not_call_me_back: boolean
  is_extra: boolean
}
export interface Bonuses {
  to_spend_amount: number
  max_spend_amount: number
  to_accrue_amount: number
  total_amount: number
  error_message: string
  message: string
}
export interface Delivery {
  point_id: number | null
  cost: Cost | null
  method: DeliveryMethods
  address_id: number | null
  order_address: string | null
}
export interface Cost {
  status: CostStatuses
  message?: string
  help_message?: string
  error_message?: string
  value?: number | string
}

export enum CostStatuses {
  FREE_DELIVERY = 'FREE_DELIVERY',
  PAID_DELIVERY = 'PAID_DELIVERY',
  UNDER_MIN_AMOUNT = 'UNDER_MIN_AMOUNT',
  OUTSIDE_DELIVERY_AREA = 'OUTSIDE_DELIVERY_AREA',
}
export enum DeliveryMethods {
  COURIER = 'courier',
  PICKUP = 'pickup',
  HALL = 'hall',
}
export enum GiftTypes {
  BIRTHDAY = 'birthday',
  PROMOCODE = 'promo_code',
  CHOICE = 'with_choice',
}
export interface Gift {
  rule_id: number
  title: string
  should_choose: false
  type: GiftTypes
  products: GiftProduct[]
}

export interface GiftProduct {
  product_id: number
  image: string
  title: string
  quantity: number
  weight: number
  measure: string
  volume_in_liters: number
  selected: boolean
}

export interface Item {
  price: number
  composition: string
  proposition_item_id: number | null
  is_proposition: boolean
  max_quantity: number | null
  total_price: number | null
  total_weight: string
  weight: string
  title: string
  quantity: number
  image_url: string
  url: string
  product_id: number
  measure: string
  volume_in_liters: number
}

export interface Persons {
  error_message: string
  help_message: string
  max_number: number | null
  message: string
  number: number | null
}

export interface AdditiveItem {
  price: number
  total_price: number
  title: string
  total_quantity: number
  image_url: string
  product_id: number
}

export interface Promocode {
  discount_amount: number
  title: string
  valid: boolean
  value: string
  error?: string
  type: PromocodeType
}

export interface Proposition {
  time_to_live: number
  popup_text: string
  items: PropositionItem[]
}

export interface PropositionItem {
  id: number
  description: string
  price: number
  name: string
  old_price: number
  image_url: string
  discount: number
  filters: string[]
  marking_composition: string
  weight: number
  measure: string
  volume_in_liters: number
}

export interface ClientPack {
  image_url: string
  product_id: number
  title: string
  total_price: number
  total_quantity: number
  price?: number
}

export enum PromocodeType {
  GIFT = 'gift',
  RELATIVE = 'relative',
  ABSOLUTE = 'absolute',
}
export interface Additive {
  type: string
  quota: number
  product_id: number
}
export interface ErrorData {
  [K: string]: string[]
}

export interface GiftPayload {
  rule_id: number
  product_id: number
}

export interface DeleteGiftPayload {
  gift_id_list: number[]
}

export interface SetDeliveryMethodPayload {
  delivery_method: DeliveryMethods
  city_domain_prefix?: string
  allow_redirect?: boolean
  address_id?: number
  point_id?: number
  order_address?: string
}

export interface SetDeliveryMethodV5BasketPayload {
  delivery_method: DeliveryMethods
  address_id?: number
  point_id?: number
  coordinates?: LatLng
}

export interface SetDeliveryMethodV5Payload {
  delivery_method: DeliveryMethods
  address_id?: number
  point_id?: number
  geo_point?: { latitude: number; longitude: number }
}

export interface AddOrSetProductPayload {
  product_id: number
  quantity: number
  product_price?: number | null
}
